import { makeStyles } from '@material-ui/core/styles'
import {
  Button,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  TextField
} from '@material-ui/core'
import { GRAY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import React, { useEffect, useState } from 'react'
import { CloseIcon } from 'asterX-UI/Icons'
import CheckIcon from '@material-ui/icons/Check'
import { DatePicker, TimePicker } from '@material-ui/pickers'
import TimerIcon from 'asterX-UI/Icons/TimerIcon'
import DateIcon from 'asterX-UI/Icons/DateIcon'
import {
  CS_ISSUE_MANAGER,
  CS_MEET_CLIENT,
  EVENT_TYPE,
  ROP_EVENT_TYPE
} from 'constants/events'
import useTaskApis from 'hooks/useTaskApis'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { useAuthStore } from 'context/AuthStore'
import moment from 'moment/moment'
import { MANAGER, ROP, SUPER_HEAD_SALES } from 'constants/roles'
import { AuthService } from 'lib/api'
import { useResErrors } from 'hooks'

const useStyles = makeStyles(() => ({
  root: {
    padding: 5
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginRight: 'auto'
  },
  btns: {
    display: 'flex',
    gap: 12,
    marginTop: 32,
    fontSize: 14
  },
  round: {
    width: 70,
    height: 70,
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '8px solid' + SUCCESS_COLORS['50'],
    backgroundColor: SUCCESS_COLORS['100'],
    margin: 'auto',
    marginBottom: 20
  },
  successText: {
    fontSize: 14,
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center'
  },
  cross: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20
  },
  row: {
    display: 'flex',
    gap: 12
  }
}))

const CreateTaskComponent = ({
  saleId,
  globalId,
  client = { contactFullname: '', phoneNumber: '', additionalPhoneNumber: '' },
  isPayment = false,
  onClose = () => {},
  onSuccess = () => {},
  isEdit = false,
  otherData = {},
  editData = {
    date: null,
    taskType: null,
    description: null
  }
}) => {
  const classes = useStyles()
  const { standardCheck } = useResErrors()
  const [isSuccessful, setIsSuccessful] = useState(false)
  const [date, setDate] = useState(editData.date)
  const [taskType, setTaskType] = useState(editData.taskType)
  const [description, setDescription] = useState(editData.description)
  const [branches, setBranches] = useState([])
  const [users, setUsers] = useState([])
  const [branch, setBranch] = useState(null)
  const [user, setUser] = useState(null)
  const { createTask, updateTask, taskIsLoading } = useTaskApis()
  const { authStore } = useAuthStore()

  const isCsIssueManager = taskType === CS_ISSUE_MANAGER
  const isManager = authStore.user?.role === MANAGER
  const eventTypes = isManager ? EVENT_TYPE : ROP_EVENT_TYPE
  const handleDateChange = date => {
    setDate(date)
  }
  useEffect(() => {
    if (isCsIssueManager && !isManager) {
      AuthService.getBranches().then(res =>
        standardCheck(res, () => {
          if (res?.data) {
            setBranches(res.data)
          } else {
            setBranches([])
          }
        })
      )
    }
  }, [taskType])

  useEffect(() => {
    if (isCsIssueManager && branch && !isManager) {
      setUser(null)
      getManagers()
    }
  }, [branch])

  const getManagers = async () => {
    await AuthService.getUsers({
      projectCode: 'CS_V2',
      isActive: true,
      offset: 0,
      limit: 100,
      userBranchCode: branch,
      roleCodes: isEdit ? undefined : [SUPER_HEAD_SALES, ROP]
    }).then(res =>
      standardCheck(res, () => {
        if (res?.data?.userList) {
          setUsers(
            res.data.userList.map(e => ({
              ...e,
              fullName: [e.firstName, e.lastName].join(' ')
            }))
          )
        } else {
          setUsers([])
        }
      })
    )
  }

  const handleTaskToogle = async () => {
    const anotherManager =
      isCsIssueManager && !isManager && users?.find(u => u.username === user)
    const assignToFullName = anotherManager
      ? `${anotherManager.fullName}`
      : `${authStore.user?.data?.lastName || ''} ${
          authStore.user?.data?.firstName || ''
        }`

    const assignTo = anotherManager ? user : authStore.user?.data?.username
    const data = {
      ...client,
      assignToFullName,
      assignTo,
      globalId,
      date,
      dealId: saleId,
      description,
      type: taskType,
      branchCode: branch || undefined,
      ...otherData
    }

    const taskToogle = isEdit ? updateTask : createTask

    await taskToogle({
      data: data,
      onSuccess: () => {
        setIsSuccessful(true)
        onSuccess()
      }
    })
  }

  const changeTaskType = ({ target: { value } }) => {
    setTaskType(value)
  }

  const changeDescription = ({ target: { value } }) => {
    setDescription(value)
  }

  return !isSuccessful ? (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.heading}>
          {isEdit ? 'Редактировать задачу' : 'Создать задачу'}
        </div>
        <IconButton
          style={{
            color: GRAY_COLORS[400]
          }}
          onClick={onClose}
          size={'medium'}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <LoaderBackdrop loading={taskIsLoading} />
      <div className={classes.container}>
        <TextField
          label={'Тип задачи'}
          value={taskType}
          onChange={changeTaskType}
          required
          select
          fullWidth
        >
          {eventTypes
            .filter(v => (isPayment ? v.code !== CS_MEET_CLIENT : true))
            .map(el => (
              <MenuItem key={el.code} value={el.code}>
                <ListItemText primary={el.name} />
              </MenuItem>
            ))}
        </TextField>
        {isCsIssueManager && (
          <>
            <TextField
              select
              label={'Филиал'}
              value={branch || ''}
              onChange={({ target: { value } }) => setBranch(value)}
              fullWidth
            >
              {branches?.map((b, i) => (
                <MenuItem key={`branch_${i}`} value={b.code}>
                  {b?.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              select
              label={isEdit ? 'Менеджер' : 'РОП'}
              value={user || ''}
              disabled={!branch}
              onChange={({ target: { value } }) => setUser(value)}
              fullWidth
            >
              {users?.map((m, i) => (
                <MenuItem key={`branch_${i}`} value={m.username}>
                  {m.fullName + ' @' + m.username}
                </MenuItem>
              ))}
            </TextField>
          </>
        )}
        <div className={classes.row}>
          <DatePicker
            label="Дата"
            format="dd.MM.yyyy"
            disablePast
            value={date}
            maxDate={moment(new Date()).add(7, 'days')}
            minDate={moment(new Date()).add(1, 'h')}
            required
            onChange={handleDateChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position={'start'}>
                  <DateIcon
                    style={{
                      color: GRAY_COLORS[500]
                    }}
                  />
                </InputAdornment>
              )
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date'
            }}
          />
          <TimePicker
            id="time-picker"
            label="Время"
            required
            ampm={false}
            value={date}
            InputProps={{
              endAdornment: (
                <InputAdornment position={'start'}>
                  <TimerIcon
                    style={{
                      color: GRAY_COLORS[500]
                    }}
                  />
                </InputAdornment>
              )
            }}
            onChange={handleDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change time'
            }}
          />
        </div>
        <TextField
          label={'Описание задачи'}
          multiline
          minRows={5}
          value={description}
          onChange={changeDescription}
          fullWidth
        />
      </div>
      <div className={classes.btns}>
        <Button
          variant={'contained'}
          fullWidth
          size={'small'}
          onClick={onClose}
        >
          Отмена
        </Button>

        <Button
          variant={'contained'}
          color={'primary'}
          fullWidth
          size={'small'}
          disabled={isCsIssueManager && !isManager && !user}
          onClick={handleTaskToogle}
        >
          {isEdit ? 'Редактировать' : 'Создать'}
        </Button>
      </div>
    </div>
  ) : (
    <div className={classes.root}>
      <div className={classes.cross}>
        <IconButton
          style={{
            color: GRAY_COLORS[400],
            fontSize: 24
          }}
          onClick={onClose}
          size={'medium'}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.round}>
        <CheckIcon style={{ fontSize: 24, color: SUCCESS_COLORS['700'] }} />
      </div>
      <div className={classes.successText}>Задача успешно создана</div>
    </div>
  )
}

export default CreateTaskComponent
